// custom-slider-image-text.js
(function() {
  'use strict';

  class SlideImageTextSwiper {
    constructor(container) {
      this.container = container;
      this.swiper = null;
      this.observer = null;
      
      this.init();
    }

    init() {
      if (!this.container) {
        console.warn('⚠️ Swiper container not found');
        return;
      }

      if (this.container.swiper) {
        this.swiper = this.container.swiper;
        return;
      }

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting && !this.swiper) {
              this.createSwiper();
              this.observer.disconnect();
            }
          });
        }, {
          rootMargin: '200px',
          threshold: 0.01,
        });
        this.observer.observe(this.container);
      } else {
        this.createSwiper();
      }
    }

    createSwiper() {
      if (!this.container || this.swiper) return;

      if (typeof Swiper === 'undefined') {
        console.warn('⚠️ Swiper library not loaded');
        return;
      }

      this._buildSwiper();
    }

    _buildSwiper() {
      // 从 data 属性读取配置
      const getData = (key, defaultValue) => {
        const value = this.container.dataset[key];
        if (value === 'true') return true;
        if (value === 'false') return false;
        return value !== undefined ? JSON.parse(value) : defaultValue;
      };

      const paginationEl = this.container.querySelector('.swiper-pagination');
      const prevEl = this.container.querySelector('.custom-arrow-prev');
      const nextEl = this.container.querySelector('.custom-arrow-next');

      const config = {
        slidesPerView: getData('slidesPerView', 1.2),
        spaceBetween: getData('spaceBetween', 16),
        loop: getData('enableLoop', false),
        autoplay: getData('enableAutoplay', false) ? {
          delay: getData('autoplayDelay', 5000),
          disableOnInteraction: false,
        } : false,
        breakpoints: {
          768: {
            slidesPerView: getData('slidesPerViewDesktop', 1.2),
            spaceBetween: getData('spaceBetweenDesktop', 16),
          },
          1024: {
            slidesPerView: getData('slidesPerViewLarge', 1.5),
            spaceBetween: getData('spaceBetweenLarge', 24),
          }
        }
      };

      if (paginationEl) {
        config.pagination = {
          el: paginationEl,
          clickable: true,
        };
      }

      if (prevEl && nextEl) {
        config.navigation = {
          nextEl: nextEl,
          prevEl: prevEl,
        };
      }

      this.swiper = new Swiper(this.container, config);
      this.container.swiper = this.swiper;
      
      console.log('✅ SlideImageTextSwiper initialized');
    }

    destroy() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
        if (this.container) {
          this.container.swiper = null;
        }
      }
    }
  }

  // ============================================================
  // 初始化所有实例
  // ============================================================
  function initAllSliders() {
    const containers = document.querySelectorAll('#slide-image-text .swiper');
    
    containers.forEach(container => {
      // 避免重复初始化
      if (container._swiperInstance) return;
      
      const instance = new SlideImageTextSwiper(container);
      container._swiperInstance = instance;
      
      // 存储实例便于清理
      const sectionId = container.dataset.sectionId || 'default';
      window.__slideImageTextInstances = window.__slideImageTextInstances || {};
      window.__slideImageTextInstances[sectionId] = instance;
    });
  }

  // 页面加载完成后初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSliders);
  } else {
    initAllSliders();
  }

  // ============================================================
  // Shopify 主题事件处理
  // ============================================================
  document.addEventListener('shopify:section:unload', function(e) {
    const sectionId = e.detail.sectionId;
    if (sectionId && window.__slideImageTextInstances?.[sectionId]) {
      window.__slideImageTextInstances[sectionId].destroy();
      delete window.__slideImageTextInstances[sectionId];
    }
  });

  document.addEventListener('shopify:section:load', function(e) {
    const sectionId = e.detail.sectionId;
    // 重新初始化
    const container = document.querySelector(`#slide-image-text .swiper[data-section-id="${sectionId}"]`);
    if (container && !container._swiperInstance) {
      const instance = new SlideImageTextSwiper(container);
      container._swiperInstance = instance;
      window.__slideImageTextInstances = window.__slideImageTextInstances || {};
      window.__slideImageTextInstances[sectionId] = instance;
    }
  });

})();